const CUSTOM_CSS_MAP = {
  fbnox: 'hyatt', // siteId: cssKeys
  fbcha: 'hyatt',
  fbcaf: 'hyatt',
  fbyum: 'hyatt',
  fbgal: 'hyatt',
  fbval: 'hyatt',
  fbcnh: 'hyatt',
  fbpot: 'hyatt',
  fblng: 'hyatt',
  fbbdg: 'hyatt'
}
const IS_DEV = process.env.NODE_ENV === 'development'
const S3_BASE = process.env.VUE_APP_SOURCE_BASE_URL
const LINK_ID = 'custom-site-css'

const loadCustomCss = async (cssUrl) => {
  return new Promise((resolve, reject) => {
    if (!cssUrl) return resolve(false)

    // 이미 붙어있으면(같은 URL이면) 스킵
    const existing = document.getElementById(LINK_ID)
    if (existing && existing.getAttribute('href') === cssUrl) {
      return resolve(true)
    }

    // 기존 커스텀 css 제거(사이트 바뀌는 경우 대비)
    if (existing) existing.parentNode && existing.parentNode.removeChild(existing);

    const link = document.createElement('link')
    link.id = LINK_ID
    link.rel = 'stylesheet'
    link.type = 'text/css'
    link.href = cssUrl

    link.onload = () => resolve(true)
    link.onerror = (e) => reject(e)

    document.head.appendChild(link)
  });
}

const removeCustomCss = () => {
  const existing = document.getElementById(LINK_ID)
  if (existing) existing.parentNode && existing.parentNode.removeChild(existing)
}
export async function getCustomSite(siteid) {
  return siteid && CUSTOM_CSS_MAP[siteid]
}
export async function applySiteCustomCss(siteid) {
  const cssKey = siteid && CUSTOM_CSS_MAP[siteid]
  if (!cssKey) {
    removeCustomCss()
    return false
  }

  const cssUrl = IS_DEV
    ? `/custom_css/${cssKey}.css`
    : `${S3_BASE}/custom/${cssKey}.css`

  await loadCustomCss(cssUrl)
  return true
}